<template>
  <slot v-if="hasAccess"></slot>
  <slot v-else name="fallback"></slot>
</template>

<script>
import { computed } from 'vue'
import { useRouter } from 'vue-router'
import { canAccessRoute } from '@/utils/permissions'

export default {
  name: 'RoutePermissionGuard',
  props: {
    // Route name or path
    route: {
      type: [String, Object],
      required: true
    }
  },
  setup(props) {
    const router = useRouter()

    const resolvedRoute = computed(() => {
      if (typeof props.route === 'string') {
        // If it's a path like '/users', resolve it
        if (props.route.startsWith('/')) {
          return router.resolve(props.route)
        }
        // If it's a name like 'users.index', resolve by name
        return router.resolve({ name: props.route })
      }
      // If it's an object like { name: 'users.index' }
      return router.resolve(props.route)
    })

    const hasAccess = computed(() => {
      return canAccessRoute(resolvedRoute.value)
    })

    return {
      hasAccess
    }
  }
}
</script>
